"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inflection_1 = __importDefault(require("inflection"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const transform_1 = __importDefault(require("lodash/transform"));
const __1 = require("..");
const Permission_1 = require("../Permission");
class JsonUtils {
}
JsonUtils.toCamel = (input) => {
    const newO = input instanceof Array ? [] : {};
    if (input instanceof Array) {
        input.forEach((currentValue, index) => {
            const newValue = JsonUtils.toCamel(currentValue);
            newO.push(newValue);
        });
    }
    else {
        for (const origKey in input) {
            if (input.hasOwnProperty(origKey)) {
                const newKey = inflection_1.default.camelize(origKey, true);
                let value = input[origKey];
                if (value && (value.constructor === Object || value.constructor === Array)) {
                    value = JsonUtils.toCamel(value);
                }
                newO[newKey] = value;
            }
        }
    }
    return newO;
};
JsonUtils.toUnderscore = (input) => {
    const newO = input instanceof Array ? [] : {};
    if (input instanceof Array) {
        input.forEach((currentValue, index) => {
            const newValue = JsonUtils.toUnderscore(currentValue);
            newO.push(newValue);
        });
    }
    else {
        for (const origKey in input) {
            if (input.hasOwnProperty(origKey)) {
                const newKey = inflection_1.default.underscore(origKey, false);
                let value = input[origKey];
                if (value && (value.constructor === Object || value.constructor === Array)) {
                    value = JsonUtils.toUnderscore(value);
                }
                newO[newKey] = value;
            }
        }
    }
    return newO;
};
JsonUtils.difference = (object, base) => {
    const changes = (obj, originalObj) => {
        return transform_1.default(obj, (result, value, key) => {
            if (!isEqual_1.default(value, originalObj[key])) {
                result[key] = (isObject_1.default(value) && isObject_1.default(originalObj[key]))
                    ? changes(value, originalObj[key])
                    : value;
            }
        });
    };
    return changes(object, base);
};
JsonUtils.transformObject = (jsonObject) => {
    const { data, included } = jsonObject;
    const flatten = (each) => {
        const relationshipRefs = !each.relationships ? {} : Object.keys(each.relationships).reduce((obj, key) => {
            obj[key] = each.relationships[key].data;
            return obj;
        }, {});
        const relationships = Object.keys(relationshipRefs).reduce((obj, key) => {
            const reference = relationshipRefs[key];
            const flattenRelationshipObject = (object) => {
                if (!object) {
                    return undefined;
                }
                return Object.assign({}, object, object.attributes, {
                    objectType: object.type,
                    objectUuid: object.id,
                });
            };
            if (reference === null) {
                return obj;
            }
            const relationship = (() => {
                if (Array.isArray(reference)) {
                    return reference.map(flattenRelationshipObject).filter((x) => x);
                }
                return flattenRelationshipObject(reference);
            })();
            obj[key] = relationship;
            return obj;
        }, {});
        return Object.assign({}, each, each.attributes, relationships, {
            isInserted: true,
            objectType: each.type,
            objectUuid: each.id,
        });
    };
    if (included) {
        __1.OMUniverse.shared.touch(included.map(flatten));
    }
    const result = (() => {
        if (Array.isArray(data)) {
            return data.map(flatten);
        }
        else {
            return [flatten(data)];
        }
    })();
    __1.OMUniverse.shared.touch(result);
    return result;
};
JsonUtils.toJsonApi = (object) => {
    const included = [];
    const toJsonApiDataObject = (eachObject, include = true) => {
        return Object.keys((eachObject)).reduce((map, key) => {
            const value = eachObject[key];
            const handleRelationship = (relObject, shouldContinue = true) => {
                const excludedList = ["ownerUuid", "groupUuid", "parentUuid"];
                if (!excludedList.includes(key)) {
                    map.relationships[key] = {
                        data: value,
                    };
                    const actualObject = relObject.actualObject;
                    const existed = (obj) => {
                        if (Array.isArray(object)) {
                            return object.some((x) => x.id === obj.id);
                        }
                        else {
                            return object.id === obj.id;
                        }
                    };
                    if (include &&
                        actualObject &&
                        !existed(actualObject) &&
                        !included.some((item) => item.id === actualObject.id) &&
                        actualObject.getPermissions().includes(Permission_1.Permission.write)) {
                        included.push(toJsonApiDataObject(relObject.actualObject, false));
                    }
                    /* Include relationship of included object */
                    if (shouldContinue && actualObject) {
                        Object.keys(actualObject).forEach((k) => {
                            const val = actualObject[k];
                            if (excludedList.includes(k)) {
                                return;
                            }
                            if (Array.isArray(val) && val.length > 0 && val[0] instanceof __1.OMReference) {
                                val.map((item) => handleRelationship(item, false));
                            }
                            if (val instanceof __1.OMReference) {
                                handleRelationship(val, false);
                            }
                        });
                    }
                }
            };
            if (key === "type") {
                return map;
            }
            if (key === "objectUuid") {
                return map;
            }
            if (key === "ownerUuid" && eachObject.objectType === "installation") {
                return map; // Skip Installation::ownerUuid prop
            }
            if (key === "ownerUuid") {
                map.attributes[key] = value && value.id;
                return map;
            }
            if (key === "groupUuid") {
                map.attributes[key] = value && value.id;
                return map;
            }
            if (Array.isArray(value) && value.length === 0) {
                return map;
            }
            if (Array.isArray(value) && value.length > 0 && value[0] instanceof __1.OMReference) {
                value.map((relObject) => handleRelationship(relObject));
                return map;
            }
            if (value instanceof __1.OMReference) {
                handleRelationship(value);
                return map;
            }
            map.attributes[key] = value;
            return map;
        }, {
            attributes: {},
            id: eachObject.id,
            relationships: {},
            type: eachObject.type || eachObject.objectType,
        });
    };
    const data = (() => {
        if (Array.isArray(object)) {
            return object.map((eachObject) => toJsonApiDataObject(eachObject));
        }
        else {
            return toJsonApiDataObject(object);
        }
    })();
    return {
        data,
        included,
    };
};
exports.default = JsonUtils;
//# sourceMappingURL=JsonUtils.js.map